module.exports = __webpack_public_path__ + "img/phone2-icon.e9f3cbfc.png";